const refreshTime = 10 * 60 * 1000; // 10 minutos

let refreshTimeout = null;

export const scheduleTokenRefresh = async (instance, account) => {
  if(!account) {
    return;
  }

  const response = await instance.acquireTokenSilent({
    scopes: ["User.Read"],
    account,
  });

  const expiresOn = response.expiresOn.getTime();
  const now = Date.now();

  let timeUntilRefresh = expiresOn - now - refreshTime;

  if(timeUntilRefresh < 0) {
    timeUntilRefresh = 0;
  }

  if(refreshTimeout) {
    clearTimeout(refreshTimeout);
  }

  refreshTimeout = setTimeout(async () => {

    await instance.acquireTokenSilent({
      scopes: ["User.Read"],
      account,
      forceRefresh: true,
    });

    scheduleTokenRefresh(instance, account);

  }, timeUntilRefresh);

}